module.exports = __webpack_public_path__ + "static/media/americanExpressIcon.beb106eb.svg";